import React from "react";
import { useSelector } from "react-redux";

const WebsiteCard = ({ weblink }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  return (
    <div className="website-card-wrapper">
      <a href={weblink.url} target="_blank" rel="noreferrer">
        <div className="website-card">
          <img
            src={process.env.REACT_APP_API_URL + weblink.image}
            alt={weblink.name_tm}
          />
          <h6>
            {lang === "en"
              ? weblink.name_en
              : lang === "ru"
              ? weblink.name_ru
              : weblink.name_tm}
          </h6>
        </div>
      </a>
    </div>
  );
};

export default WebsiteCard;
